module.exports = __webpack_public_path__ + "img/2010 winteressen 027.70593b1d.jpg";